
import { Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function LoadingState() {
  const { t } = useLanguage();
  
  return (
    <div className="flex items-center justify-center py-4">
      <Loader2 className="h-5 w-5 animate-spin mr-2" />
      <span>{t("common.loading")}</span>
    </div>
  );
}
